export const getEventDetailsSideBarWidth = (initialWidth: number): number =>
  initialWidth * 55 + 225;
